import { Project } from '../types/project.types';

export const projects: Project[] = [
    {
        title: "Sustainable Routing Laboratory",
        description: "I developed a data visualization website in scope of a research project at the University of St. Gallen.",
        technologies: ["React", "TypeScript", "OSMnx", "Python", "Flask", "Routing APIs"],
        githubUrl: "https://github.com/sebioes/sus-routing-lab",
        liveUrl: "https://routing-lab.sebastianoes.ch/"
    },
    {
        title: "SAGE Mission Control Software",
        description: "I was involved planning and developing the Mission Control Software for the SAGE CubeSat Mission. It will play a key role in operating the satellite which will be launched in 2026.",
        technologies: ["React", "TypeScript", "Material-UI"],
        githubUrl: "https://github.com/aris-space/sage-moc",
        liveUrl: "https://sage-moc-frontend.vercel.app/"
    },
    {
        title: "dominOS",
        description: "Together with a team of 3, I developed a fun domino stone placing solution in scope of the robotics class at the University of St. Gallen.",
        technologies: ["Python", "OpenCV", "SwiftUI"],
        githubUrl: "https://github.com/sebioes/dominos",
        liveUrl: "https://youtu.be/DlCYR3aoZqQ?si=AKY57p-pYP58n7eI"
    },
    {
        title: "SAGE CubeSat Mission",
        description: "As a member of the SAGE team, I was involved in the development of the CubeSat Mission. I was responsible for system engineering and the development of the mission control software."
    }
]; 
